import { base } from './';
const PATH = '/aws-s3-upload';

const upload = (file: File, directory?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  if (directory) formData.append('directory', directory);

  return base.post(PATH, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const uploadContentsImage = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const isDev = process.env.REACT_APP_ENV === 'dev';
  const directory = isDev ? 'contents/dev' : 'contents';
  formData.append('directory', directory);

  return base.post(`${PATH}/original`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export { upload, uploadContentsImage };
